export default "__VITE_ASSET__krUf9HrM__"